// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/index.less
// module id = 60
// module chunks = 0